import { Helmet } from "react-helmet-async";
import Table, { TableHeader } from "../../../shared/Table";
import TabPosition from "../../../shared/TabPosition";
import { TranslationService } from "../../../../services/TranslationService";
import { useLocation } from "react-router-dom";
import { ScheduledTaskListRequest } from "../../entities/scheduledTask/ScheduledTaskListRequest";
import { Switch } from "../../../../utils/Utils";
import CompanyService from "../../../../services/CompanyService";
import ScheduleTaskTableItem from "./ScheduleTaskTableItem";
import ScheduledTaskTableProvider from "./ScheduledTaskTableProvider";
import { FixToTop } from "../../../shared/FixToTop";
import FilterScheduledTask from "./FilterScheduledTask";

const ScheduleTaskList: React.FC = () => {
  const { state, search } = useLocation<
    { prevRequest?: ScheduledTaskListRequest } | undefined
  >();
  const urlParams = new URLSearchParams(search);
  const userIdQS =
    (state?.prevRequest ? state.prevRequest.personId : urlParams.get("uid")) ??
    "";
  //const { translate, currentLanguage } = TranslationService;

  const prevRequest = Switch(
    [Boolean(state?.prevRequest), state?.prevRequest],
    [
      Boolean(urlParams.get("filter")),
      () => {
        const req = new ScheduledTaskListRequest(
          userIdQS,
          CompanyService.getAdditionalDefinitions()
        );
        req.filter = urlParams.get("filter") ?? "";
        return req;
      }
    ]
  );

  const tableHeaders: TableHeader[] = [
    new TableHeader(
      "Client",
      TranslationService.translate.Client,
      false,
      true,
      "w-200px"
    ),
    new TableHeader(
      "Responsible",
      TranslationService.translate.Responsible,
      true,
      true,
      "text-start"
    ),
    new TableHeader(
      "RememberDays",
      TranslationService.translate.Expiration,
      true,
      true,
      "text-start"
    ),
    new TableHeader(
      "DueDays",
      TranslationService.translate.HeaderWhen,
      false,
      true,
      "text-start"
    ),
    new TableHeader(
      "Description",
      TranslationService.translate.HeaderDescription,
      false,
      true,
      "w-200px text-start"
    )
  ];

  return (
    <TabPosition module="task">
      <Helmet>
        <title>Intiza</title>
      </Helmet>

      <div className="container-fluid padding">
        <div className="d-flex justify-content-between">
          <h2>{TranslationService.translate.ScheduledTasks}</h2>
        </div>

        <div className="card mh-100 p-0">
          <ScheduledTaskTableProvider
            userId={userIdQS === "" ? null : userIdQS}
            request={prevRequest}
          >
            <FixToTop>
              <FilterScheduledTask></FilterScheduledTask>
            </FixToTop>

            <Table
              emptyMessage={TranslationService.translate.NoTasksFound}
              stickyHeader={true}
              headers={tableHeaders}
              item={ScheduleTaskTableItem}
              fillHeight={true}
            />
          </ScheduledTaskTableProvider>
        </div>
      </div>
    </TabPosition>
  );
};

export default ScheduleTaskList;
